// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".radioGroup__group--P4kQh {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0.938rem;\n}\n\n.radioGroup__selected--K5gpf label {\n    color: #FF7535;\n  }\n", "",{"version":3,"sources":["webpack://./src/components/form/radioGroup.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAsB;AACxB;;AAIE;IACE,cAAoB;EACtB","sourcesContent":[".group {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: rem(15);\n}\n\n.selected {\n\n  label {\n    color: var(--orange);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"group": "radioGroup__group--P4kQh",
	"selected": "radioGroup__selected--K5gpf"
};
module.exports = ___CSS_LOADER_EXPORT___;
